import { render } from "./ProjectFiles.vue?vue&type=template&id=993b19b4&scoped=true"
import script from "./ProjectFiles.vue?vue&type=script&lang=js"
export * from "./ProjectFiles.vue?vue&type=script&lang=js"

import "./ProjectFiles.vue?vue&type=style&index=0&id=993b19b4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-993b19b4"]])

export default __exports__